import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";

var Embed = function Embed(_ref) {
  var children = _ref.children;
  return _jsx(_Fragment, {
    children: children
  });
};

export default Embed;